import { render, staticRenderFns } from "./FormGaleria.vue?vue&type=template&id=1931cd8c"
import script from "./FormGaleria.vue?vue&type=script&lang=js"
export * from "./FormGaleria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports